function normalizeEmail(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed && trimmed.includes('@') ? trimmed : null;
}

function normalizePhone(value) {
  if (typeof value !== 'string') return null;
  return value.trim() || null;
}

export function resolvePublicContact(tenant) {
  return {
    email: normalizeEmail(tenant?.websiteContact?.contactEmail),
    phone: normalizePhone(tenant?.websiteContact?.contactPhone),
  };
}
